import { styled } from "@vitality-ds/system";
import baseBreadcrumbConstrainedWidthContainerStyles from "./styles/BaseBreadcrumbConstrainedWidthContainer.styles";
import baseBreadcrumbLinkStyles from "./styles/BaseBreadcrumbLink.styles";
import baseBreadcrumbListItemStyles from "./styles/BaseBreadcrumbListItem.styles";
import baseBreadcrumbTextStyles from "./styles/BaseBreadcrumbText.styles";
export var BaseBreadcrumbListItem = styled("li", baseBreadcrumbListItemStyles);
export var BaseBreadcrumbLink = styled("a", baseBreadcrumbTextStyles, baseBreadcrumbLinkStyles);
export var BaseBreadcrumbText = styled("span", baseBreadcrumbTextStyles);
export var BaseBreadcrumbConstrainedWidthContainerStyles = styled("div", baseBreadcrumbConstrainedWidthContainerStyles);